import React, {useMemo} from 'react';
import {Select, SelectProps, Alert} from 'fearless-common-ui';
import useGet from '../hooks/useGet';

/**
 * Create an HTML <select> component based on options retrieved from the backend.
 */
export default function BackendSelect<ArrayItems extends Record<string, string> | ({ id: string | number; name: string }[])>({ endpoint, resultProcessor = undefined, ...props }: {
    resultProcessor?: (items: ArrayItems) => SelectProps['options'],
    endpoint: string;
} & Omit<SelectProps, 'options'>) {
    const { data, isLoading, error } = useGet<ArrayItems>({ endpoint });

    const modifiedData = useMemo(() => {
        if (resultProcessor && data) {
            return resultProcessor(data);
        }
        return Array.isArray(data)
            ? data.map((record) => ({ value: record.id, label: record.name }))
            : [];
    }, [resultProcessor, data])

    return error ? <Alert variant="danger">{error}</Alert> : (
        <Select
            {...props}
            options={modifiedData}
            placeholder={isLoading ? 'Loading...' : props.placeholder}
            disabled={isLoading || props.disabled}
        />
    );
}
